export default __webpack_public_path__ + "static/pragicts-secops-banner-single-vulnerability-d5d107f7815db2610bc2f67b3db6fa87.jpg";